export default __webpack_public_path__ + "images/NK.2637422.png";